import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Input, Row, Select } from "antd";
import {
  LeftOutlined,
  SendOutlined,
  ArrowLeftOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import GenerateContentContainer from "./components/GenerateContentContainer";
import OpenAiChatItem from "./components/OpenAiChatItem";

import AppUrl from "../config/appUrl";
import { hasApiCallError, showNotification } from "../utils/commonFunctions";

import "./OpenAi.scss";
import constants from "../utils/constants";

function secureUID() {
  return crypto.randomUUID();
}

const OpenAiChat = () => {
  const messageRefs = useRef([]);
  const navigate = useNavigate();

  const [state, setState] = useState({
    message: "",
  });
  const [messages, setMessages] = useState([]);
  const [aiModel, setAiModel] = useState([]);
  const [modelValue, setModelValue] = useState("gpt-4.1");
  const [sessionId, setSessionId] = useState(null);
  const [generatedTitle, setGeneratedTitle] = useState(null);

  useEffect(() => {
    axios.get(`${AppUrl.OPENAI_MODEL_LIST}`).then((response) => {
      console.log("-----Openai", response?.data?.data);

      setAiModel(response?.data?.data);
    });
    if(!sessionId){
      setSessionId(secureUID())
      setGeneratedTitle("New Chat")
    }
    // axios.get(`${AppUrl.GEMINI_MODEL_LIST}`).then((response) => {
    //   // setAiModel(response?.data?.data);
    //   console.log("-----Gemini", response?.data?.data)
    // })
    // axios.get(`${AppUrl.DEEPSEEK_MODEL_LIST}`).then((response) => {
    //   // setAiModel(response?.data?.data);
    //   console.log("-----Deepseek", response?.data?.data)
    // })
  }, []);

  const handleModelSelect = (value) => {
    let getPreviousModelName = aiModel.find(
      (o) => o?.id === (modelValue || "gpt-4.1")
    )?.name;
    let getNewModelName = aiModel.find(
      (o) => o?.id === (value || "gpt-4.1")
    )?.name;
    // const mapper = (value) => {
    //   switch (value) {
    //     case "gpt-4.1":
    //       return "gpt-4.1";
    //   }
    // }
    const newMessages = messages;
    newMessages.push({
      role: "custom-model-switch",
      content: `<strong>You’ve switched from <i>${getPreviousModelName}</i> ➡️ <i>${getNewModelName}</i></strong>`,
      model: "custom-model",
    });
    setModelValue(value);
  };
  const onGoBack = useCallback(() => navigate(-1), [navigate]);

  const sendMessage = async (input) => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);

    console.log("Added", input);
    const response = await fetch(`${AppUrl.OPENAI}/deep_research/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(input),
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    setMessages((prev) => {
      const updated = [...prev];
      const lastIndex = updated.length - 1;

      updated[lastIndex] = {
        ...updated[lastIndex],
        content: "",
      };

      return updated;
    });
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n").filter((line) => line.trim() !== "");

      for (const line of lines) {
        if (line === "data: [DONE]") {
          setState((prevState) => ({ ...prevState, loading: false }));
          setMessages((prev) => {
            const updated = [...prev];
            const lastIndex = updated.length - 1;
            updated[lastIndex] = { ...updated[lastIndex], loading: false };
            return updated;
          });
          return;
        }

        if (line.startsWith("data: ")) {
          try {
            const token = JSON.parse(line.replace("data: ", ""));
            // const token = json;
            setMessages((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;

              updated[lastIndex] = {
                ...updated[lastIndex],
                content: updated[lastIndex].content + token,
              };

              return updated;
            });
            const lastMessageIndex = messages.length - 1;
            setTimeout(
              () =>
                messageRefs?.current?.[lastMessageIndex + 1]?.scrollIntoView?.({
                  behavior: "smooth",
                }),
              100
            );
          } catch (err) {
            console.log(err);
            // skip invalid chunks
          }
        }
      }
    }
  };

  // const sendGeminiMessage = async (input) => {
  //   const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);

  //   console.log("Added", input);

  //   const response = await fetch(`${AppUrl.OPENAI}/gemini/chat`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //     body: JSON.stringify(input),
  //   });

  //   if (!response.ok || !response.body) {
  //     console.error("Gemini stream failed:", response.statusText);
  //     setState((prev) => ({ ...prev, loading: false }));
  //     return;
  //   }

  //   const reader = response.body.getReader();
  //   const decoder = new TextDecoder("utf-8");

  //   // Initialize empty assistant message
  //   setMessages((prev) => {
  //     const updated = [...prev];
  //     const lastIndex = updated.length - 1;

  //     updated[lastIndex] = {
  //       ...updated[lastIndex],
  //       content: "",
  //       loading: true,
  //     };

  //     return updated;
  //   });

  //   try {
  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;

  //       const chunk = decoder.decode(value, { stream: true });
  //       const lines = chunk
  //         .split("\n")
  //         .map((l) => l.trim())
  //         .filter((l) => l !== "");

  //       for (const line of lines) {
  //         if (line === "data: [DONE]") {
  //           setState((prev) => ({ ...prev, loading: false }));
  //           setMessages((prev) => {
  //             const updated = [...prev];
  //             const lastIndex = updated.length - 1;
  //             updated[lastIndex] = { ...updated[lastIndex], loading: false };
  //             return updated;
  //           });
  //           return;
  //         }

  //         if (line.startsWith("data: ")) {
  //           try {
  //             const json = JSON.parse(line.replace("data: ", ""));
  //             // 👇 Fix: safely extract text token
  //             const token =
  //               typeof json === "string"
  //                 ? json
  //                 : json.text || json.delta || json.output || "";

  //             if (token) {
  //               setMessages((prev) => {
  //                 const updated = [...prev];
  //                 const lastIndex = updated.length - 1;
  //                 updated[lastIndex] = {
  //                   ...updated[lastIndex],
  //                   content: (updated[lastIndex].content || "") + token,
  //                 };
  //                 return updated;
  //               });
  //             }
  //           } catch (err) {
  //             console.warn("Gemini parse error:", err);
  //           }
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Gemini stream error:", err);
  //   } finally {
  //     setState((prev) => ({ ...prev, loading: false }));
  //   }
  // };

  const sendGeminiMessage = async (input) => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
    console.log("Added", input);

    // Start loading
    setState((prev) => ({ ...prev, loading: true }));

    const response = await fetch(`${AppUrl.OPENAI}/gemini/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(input),
    });

    if (!response.ok || !response.body) {
      console.error("Gemini stream failed:", response.statusText);
      setState((prev) => ({ ...prev, loading: false }));
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    // === Show "typing..." animation before first token ===
    setMessages((prev) => {
      const updated = [...prev];
      const lastIndex = updated.length - 1;
      updated[lastIndex] = {
        ...updated[lastIndex],
        content: "typing",
        loading: true,
        isTyping: true,
      };
      return updated;
    });

    let receivedFirstToken = false;

    const typingInterval = setInterval(() => {
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        if (updated[lastIndex]?.isTyping) {
          const dots =
            updated[lastIndex].content.length >= 10
              ? "typing"
              : updated[lastIndex].content + ".";
          updated[lastIndex] = { ...updated[lastIndex], content: dots };
        }
        return updated;
      });
    }, 400);

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l !== "");

        for (const line of lines) {
          if (line === "data: [DONE]") {
            clearInterval(typingInterval);
            setState((prev) => ({ ...prev, loading: false }));
            setMessages((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;
              updated[lastIndex] = {
                ...updated[lastIndex],
                loading: false,
                isTyping: false,
              };
              return updated;
            });
            return;
          }

          if (line.startsWith("data: ")) {
            try {
              const json = JSON.parse(line.replace("data: ", ""));
              const token =
                typeof json === "string"
                  ? json
                  : json.text || json.delta || json.output || "";

              if (token) {
                if (!receivedFirstToken) {
                  clearInterval(typingInterval);
                  receivedFirstToken = true;

                  setMessages((prev) => {
                    const updated = [...prev];
                    const lastIndex = updated.length - 1;
                    updated[lastIndex].content = "";
                    updated[lastIndex].isTyping = false;
                    return updated;
                  });
                }

                setMessages((prev) => {
                  const updated = [...prev];
                  const lastIndex = updated.length - 1;
                  updated[lastIndex] = {
                    ...updated[lastIndex],
                    content: (updated[lastIndex].content || "") + token,
                  };
                  return updated;
                });
              }
            } catch (err) {
              console.warn("Gemini parse error:", err);
            }
          }
        }
      }
    } catch (err) {
      console.error("Gemini stream error:", err);
    } finally {
      clearInterval(typingInterval);
      setState((prev) => ({ ...prev, loading: false }));
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        updated[lastIndex] = {
          ...updated[lastIndex],
          loading: false,
          isTyping: false,
        };
        return updated;
      });
    }
  };

  const sendAnthropicMessage = async (input) => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);

    // === Extract user message safely ===
    const messages = input?.messages || [];
    const lastMessage = messages[messages.length - 1];
    const userText = (lastMessage?.content || input?.message || "").trim();

    console.log("Input:", input);
    console.log("Added:", userText);

    if (!userText) {
      console.error("Anthropic Error: message content cannot be empty");
      return;
    }

    // === Start loading ===
    setState((prev) => ({ ...prev, loading: true }));

    const payload = {
      model: "claude-3-5-sonnet-20240620",
      max_tokens: 1024,
      messages: [{ role: "user", content: userText }],
      session_id: input.session_id || null,
      title: input.title || "Untitled Chat",
    };

    try {
      const response = await fetch(`${AppUrl.OPENAI}/anthropic/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok || !response.body) {
        throw new Error(`Anthropic stream failed: ${response.statusText}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      // === Set initial "typing..." message ===
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        updated[lastIndex] = {
          ...updated[lastIndex],
          content: "typing",
          isTyping: true,
          loading: true,
        };
        return updated;
      });

      let receivedFirstToken = false;

      // === Typing animation ===
      const typingInterval = setInterval(() => {
        setMessages((prev) => {
          const updated = [...prev];
          const lastIndex = updated.length - 1;
          if (updated[lastIndex]?.isTyping) {
            const dots =
              updated[lastIndex].content.length >= 10
                ? "typing"
                : updated[lastIndex].content + ".";
            updated[lastIndex] = { ...updated[lastIndex], content: dots };
          }
          return updated;
        });
      }, 400);

      // === Stream data chunks ===
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l !== "");

        for (const line of lines) {
          if (line === "data: [DONE]") {
            console.log("Anthropic stream finished.");
            clearInterval(typingInterval);
            setState((prev) => ({ ...prev, loading: false }));
            setMessages((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;
              updated[lastIndex] = {
                ...updated[lastIndex],
                isTyping: false,
                loading: false,
              };
              return updated;
            });
            return;
          }

          if (line.startsWith("data: ")) {
            try {
              const json = JSON.parse(line.replace("data: ", ""));
              const token = json.text || "";

              if (token) {
                if (!receivedFirstToken) {
                  receivedFirstToken = true;
                  clearInterval(typingInterval);
                  setMessages((prev) => {
                    const updated = [...prev];
                    const lastIndex = updated.length - 1;
                    updated[lastIndex] = {
                      ...updated[lastIndex],
                      content: "",
                      isTyping: false,
                      loading: true,
                    };
                    return updated;
                  });
                }

                setMessages((prev) => {
                  const updated = [...prev];
                  const lastIndex = updated.length - 1;
                  updated[lastIndex] = {
                    ...updated[lastIndex],
                    content: (updated[lastIndex].content || "") + token,
                  };
                  return updated;
                });
              }
            } catch (err) {
              console.warn("Anthropic parse error:", err);
            }
          }
        }
      }
    } catch (err) {
      console.error("Anthropic stream error:", err);
    } finally {
      // === Always clean up ===
      setState((prev) => ({ ...prev, loading: false }));
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        if (updated[lastIndex]) {
          updated[lastIndex] = {
            ...updated[lastIndex],
            isTyping: false,
            loading: false,
          };
        }
        return updated;
      });
    }
  };

  const onSend = useCallback(() => {
    const message = state.message.trim();

    if (!message) return;

    const newMessages = messages;

    newMessages.push({
      role: "user",
      content: message,
      model: modelValue || "gpt-4.1",
    });
    const payload = {
      messages: [...newMessages].filter(
        (o) => o.model === (modelValue || "gpt-4.1")
      ),
      model: modelValue || "gpt-4.1",
      title: generatedTitle,
      session_id: sessionId
    };

    newMessages.push({
      role: "assistant",
      content: "typing...",
      model: modelValue || "gpt-4.1",
      loading: true,
    });

    setMessages(newMessages);
    setState((prevState) => ({ ...prevState, message: "", loading: true }));

    const lastMessageIndex = messages.length - 1;
    setTimeout(
      () =>
        messageRefs?.current?.[lastMessageIndex]?.scrollIntoView?.({
          behavior: "smooth",
        }),
      100
    );

    console.log("------>", modelValue);
    //

    const gptModel = {
      // "gpt-5": "chatgpt",
      "gpt-4": "chatgpt",
      "gpt-4.1": "chatgpt",
      "gpt-4.1-mini": "chatgpt",
      "gpt-4.1-nano": "chatgpt",
      "o3-deep-research-2025-06-26": "deep_research",
      "gemini-2.5-flash": "gemini",
      "gemini-1.5-pro": "gemini",
      "gemini-2.5-pro": "gemini",
      "gemini-1.5-flash": "gemini",
      "claude-3-5-sonnet-20241022": "anthropic",
      "claude-3-5-sonnet-20240620": "anthropic",
    };

    console.log("-----", gptModel[modelValue]);
    if (
      gptModel[modelValue] === "deep_research" ||
      gptModel[modelValue] === "chatgpt"
    ) {
      sendMessage(payload);
    } else if (gptModel[modelValue] === "gemini") {
      sendGeminiMessage(payload);
    } else if (gptModel[modelValue] === "anthropic") {
      sendAnthropicMessage(payload);
    } else {
      axios({
        method: "POST",
        // url: `https://hertz-chatbot.ibism.com/chat/ask_query`,
        // data: {
        //   "user_id":"session_id_MOnTpGgZgFfEqlby",
        //   "query": message
        // }
        url: `${AppUrl.OPENAI}/chat`,
        data: payload,
      })
        .then((response) => {
          const resData = response.data;

          if (hasApiCallError(resData?.meta)) {
            setMessages((prevMessages) => {
              const lastMesssage = prevMessages.pop();
              console.log("remove message: ", lastMesssage);

              return [...prevMessages];
            });
          } else {
            const newMessage =
              resData?.data?.content ||
              resData?.response ||
              resData?.data?.response;
            let content =
              newMessage?.content ||
              resData?.response ||
              resData?.data?.response;
            while (content.startsWith("\n")) {
              content = content.replace("\n", "");
            }
            newMessage.content = content;
            newMessage.model = modelValue || "gpt-4.1";
            setTimeout(
              () =>
                messageRefs?.current?.[lastMessageIndex + 1]?.scrollIntoView?.({
                  behavior: "smooth",
                }),
              100
            );

            setMessages((prevMessages) => {
              prevMessages.pop();

              return [...prevMessages, newMessage];
            });
          }

          setState((prevState) => ({ ...prevState, loading: false }));
        })
        .catch((err) => {
          console.log("chat err: ", err);
          showNotification("error", "Something went wrong");
          setMessages((prevMessages) => {
            const lastMesssage = prevMessages.pop();
            console.log("remove message: ", lastMesssage);

            return [...prevMessages];
          });
          setState((prevState) => ({ ...prevState, loading: false }));
        });
    }
  }, [messages, state, messageRefs]);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e;

      setState((prevState) => {
        prevState[name] = value;
        return { ...prevState };
      });
    },
    []
  );

  return (
    <>
      <GenerateContentContainer containerClassName="open-ai-chat open-ai-cb set-bg set-container">
        <Col className="content-container h-full">
          {/* heading start */}
          <Row className="fw" justify="space-between">
            <Col className="title-container w-full mb15">
              <Row className="w-full d-flex-open-ai" align="middle">
                <div className="back-icon mr-3">
                  <LeftOutlined className="text-2xl" onClick={onGoBack} />
                </div>
                <Row align="middle">
                  <span className="icon-round mr-3">
                    <img
                      className=""
                      src="/img/icons/robot-icon.svg"
                      alt="Writely Bot"
                      srcset=""
                    />
                  </span>
                  <span>Writely Bot</span>
                </Row>
                <Row align="flex-end" className="ml-auto mr-5">
                  <Select
                    className="new_select fw"
                    style={{ minWidth: 160 }}
                    placeholder="Select Model"
                    // suffixIcon={<CaretDownOutlined style={{ color: "#fff" }} />}
                    clearIcon={
                      <CloseCircleOutlined
                        style={{
                          color: "#fff",
                          background: "#000",
                          fontSize: 13,
                        }}
                      />
                    }
                    size="large"
                    dropdownMatchSelectWidth={false}
                    value={modelValue || "Gpt4.1 by OpenAI"}
                    onChange={handleModelSelect}
                    // showSearch
                    // allowClear
                  >
                    {aiModel?.map?.((item, i) => (
                      <Select.Option key={item?.id} value={item?.id}>
                        {item?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Row>
              </Row>
            </Col>
          </Row>
          {/* heading end */}

          {/* chat container start */}
          <Col className="chat-container">
            <Col className="message-list-container mb-20 ">
              {messages?.map?.((message, i) => (
                <div key={i} ref={(mRef) => (messageRefs.current[i] = mRef)}>
                  <OpenAiChatItem key={i} message={message} />
                </div>
              ))}
              {!messages.length && (
                <Row className="h-full" align="middle" justify="center">
                  <img
                    className="h-64 w-full"
                    src="/img/empty-ai-chat.svg"
                    alt="Writely Bot"
                    srcset=""
                  />
                </Row>
              )}
            </Col>
          </Col>

          {/* chat container end */}

          {/* chat input container end */}
          <Card className="chat-input-container">
            <Row align="bottom">
              <Col className="grow">
                <Input.TextArea
                  className="chat-input"
                  value={state.message}
                  placeholder="Type your question or topic of interest here"
                  onChange={handleChange("message")}
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  onPressEnter={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      onSend();
                    }
                  }}
                  disabled={state.loading}
                  size="large"
                />
              </Col>

              <Button
                className="text-2xl"
                type="text"
                onClick={onSend}
                disabled={!state.message.trim()}
                loading={state.loading}
                size="large"
                icon={<SendOutlined className="text-3xl" />}
              />
            </Row>
          </Card>
          {/* chat input container end */}
        </Col>
      </GenerateContentContainer>
    </>
  );
};

export default React.memo(OpenAiChat);
